<template>
  <section class="prod-item" :class="[isDetail ? 'is-detail' : '']">
    <div class="prod-item-inner">
      <!-- 标签 -->
      <div class="extra-tag" v-if="item.first_buy == 1 && item.first_pay_icon">{{ item.first_pay_icon }}</div>
      <div class="extra-tag" v-if="item.first_buy == 0 && item.pay_icon">{{ item.pay_icon }}</div>
      <main>
        <!-- 图片 -->
        <div class="img-wrapper" @click="openProdDesc(item)">
          <div class="img-inner">
            <img :src="item.product_file_url" alt="" />
          </div>
        </div>
        <!-- 主标题+详情图标 -->
        <p class="main-title">
          <span :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">{{ item.product_name }}</span>
          <img
            v-if="!isDetail && item.product_content"
            @click="openProdDesc(item)"
            src="../../../assets/imgs/pay/icon_info.png"
            style="width: .25rem;vertical-align: middle"
            alt=""
          />
        </p>
        <!-- 列表:副标题  详情:产品内容-->
        <p v-if="getSubtitle(item)" class="sub-title" :dir="isDetail && $i18n.locale === 'ar' ? 'rtl' : 'ltr'">
          {{ getSubtitle(item) }}
        </p>
      </main>

      <footer>
        <!-- 价格 -->
        <LnButton type="primary" @click.native="currentOnPayProd(item)">
          <span v-if="area == 'kr'">₩</span>
          <span v-if="area != 'kr'">$</span>
          <span>{{ item.amount }}</span>
        </LnButton>

        <!-- 购买限制 -->
        <div v-if="item.role_buy_limit_progress" class="limit">
          {{ item.role_buy_limit_progress }}
        </div>
      </footer>
    </div>
  </section>
</template>

<script>
import LnButton from '../../../components/LnButton.vue';
import { useDialog } from '../../../features/dialog/use-dialog';
import { delay } from '../../../utils';

export default {
  components: {
    LnButton
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    area: {
      type: String,
      default: ''
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    onPayProd: {
      type: Function,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    const { confirm } = useDialog();
    function openProdDesc(item) {
      if (props.isDetail) return;
      emit('openProdDesc', item);
    }

    function getSubtitle(item) {
      if (props.isDetail) {
        return item.product_content;
      } else if (item.first_buy == 1 && item.first_pay_content) {
        return item.first_pay_content;
      } else if (item.first_buy == 0) {
        return item.pay_content;
      }
    }

    async function currentOnPayProd(...args) {
      if (props.isDetail) {
        // 详情页是弹窗，在弹窗动画结束后再执行逻辑
        confirm();
        // 300是动画结束后
        await delay(300);
        props.onPayProd(...args);
      } else {
        props.onPayProd(...args);
      }
    }

    return {
      openProdDesc,
      getSubtitle,
      currentOnPayProd
    };
  }
};
</script>

<style lang="scss" scoped>
.prod-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  &.is-detail {
    .prod-item-inner {
      width: 60vw;
      max-width: 450px; // 兼容PC
    }
  }
  .prod-item-inner {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 0.14rem;
    position: relative;
    border-radius: 0.2rem;
    border: 1px solid rgb(228, 228, 228);
    .extra-tag {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 0;
      top: 0;
      height: 0.5rem;
      padding: 0 0.12rem;
      background: #fe0000;
      border-radius: 0.1rem;
      font-family: SourceHanSansCN;
      font-weight: 800;
      font-size: 0.24rem;
      color: #ffffff;
    }
    main {
      flex: 1;
      display: flex;
      flex-direction: column;
      .img-wrapper {
        padding: 0.55rem 0.45rem 0;
        flex-shrink: 0;
        .img-inner {
          padding-top: 100%;
          position: relative;
          > img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;
            background: #f1f1f1;
          }
        }
      }
      .main-title {
        font-family: SourceHanSansCN;
        font-weight: bold;
        font-size: 0.22rem;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0.1rem;
        > img {
          width: 0.25rem;
          margin-left: 0.05rem;
        }
      }
      .sub-title {
        padding-top: 0.05rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 0.2rem;
        color: #969696;
        white-space: pre-wrap;
      }
    }

    footer {
      .ln-button {
        margin-top: 0.15rem;
      }
      .limit {
        padding-top: 0.1rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 0.2rem;
        color: #969696;
      }
    }
  }
}
</style>
